import { Fragment, type ReactNode } from 'react'

function renderInlineEmphasis(
  input: string,
  keyPrefix: string
): Array<ReactNode> {
  const parts: Array<ReactNode> = []
  const pattern = /(\*\*[^*]+\*\*|__[^_]+__)/g
  let lastIndex = 0
  let match: RegExpExecArray | null
  let tokenIndex = 0

  while ((match = pattern.exec(input)) !== null) {
    const [token] = match
    if (match.index > lastIndex) {
      parts.push(input.slice(lastIndex, match.index))
    }

    if (token.startsWith('**') && token.endsWith('**')) {
      parts.push(
        <strong key={`${keyPrefix}-strong-${tokenIndex}`}>
          {token.slice(2, -2)}
        </strong>
      )
    } else if (token.startsWith('__') && token.endsWith('__')) {
      parts.push(
        <em key={`${keyPrefix}-em-${tokenIndex}`}>{token.slice(2, -2)}</em>
      )
    } else {
      parts.push(token)
    }

    lastIndex = match.index + token.length
    tokenIndex += 1
  }

  if (lastIndex < input.length) {
    parts.push(input.slice(lastIndex))
  }

  return parts
}

export function renderSeoReportLimitedMarkdown(input: string): ReactNode {
  const paragraphs = input
    .trim()
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.replace(/\n/g, ' ').trim())
    .filter(Boolean)

  if (paragraphs.length === 0) {
    return null
  }

  return (
    <>
      {paragraphs.map((paragraph, index) => (
        <Fragment key={`paragraph-${index}`}>
          {index > 0 ? (
            <>
              <br />
              <br />
            </>
          ) : null}
          {renderInlineEmphasis(paragraph, `paragraph-${index}`)}
        </Fragment>
      ))}
    </>
  )
}
